import { forwardRef, memo } from "react";
import classnames from "classnames";
import { StepBase } from "../../StepBase";
import { ProgressStepItem, ProgressStepProps } from "../types";
import { getIndicatorState } from "../utils";

import styles from "./style.module.scss";

export type ProgressTextWithLineProps = ProgressStepProps;

export const ProgressTextWithLine = memo(
  forwardRef<HTMLDivElement, ProgressTextWithLineProps>(
    (
      {
        size = "sm",
        steps,
        className,
        currentStep = 0,
        ...props
      },
      ref,
    ) => {

      return (
        <div
          className={classnames(styles.root, className)}
          {...props}
          ref={ref}
        >
          {steps?.map((item: ProgressStepItem, index: number) => {
            return (
              <StepBase
                {...item}
                id={`${item?.id}`}
                key={item.id}
                size={size}
                type={"line"}
                status={getIndicatorState(index, currentStep)}
              />
            );
          })}
        </div>
      );
    },
  ),
);
